<template>
	<div class="flex flex-row justify-content-between align-items-center m-2 bg-grey">
		<div class="flex flex-row align-items-center">
			<div class="pi pi-volume-up text-xs mr-2" />
			<span class="mr-2">Status alert sound:</span>
			<PSelectButton
				:allowEmpty="false"
				:options="options"
				aria-labelledby="status-alert-mute"
				v-model="selection"
				@click="save()"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Constants from '@/helpers/Constants'
import PB from '@/brokers/PersistencyBroker'
import Utils from '@/utils/Utils'
import EventBus from '@/utils/EventBus'
import { silenceAlertSound, unlockAlertSound } from '@/utils/AlertSound'

export default defineComponent({
	name: 'WStatusAlertMute',

	data() {
		return {
			selection: 'On',
			options: ['On', 'Muted'],
			before: 'On',
		}
	},

	created() {
		const muted = PB.get(Constants.LOCAL_STORAGE_IDS.STATUS_ALERT_MUTED)
		this.selection = muted === 'true' ? 'Muted' : 'On'
		this.before = this.selection
		EventBus.on(Constants.EVENTS.STATUS_ALERT_MUTE_CHANGED, this.onMuteChanged)
	},

	beforeUnmount() {
		EventBus.off(Constants.EVENTS.STATUS_ALERT_MUTE_CHANGED, this.onMuteChanged)
	},

	methods: {
		onMuteChanged(muted: unknown) {
			const selection = muted ? 'Muted' : 'On'
			this.selection = selection
			this.before = selection
		},

		save() {
			if (this.selection === this.before) {
				return
			}
			const muted = this.selection === 'Muted'
			if (muted) {
				silenceAlertSound()
			} else {
				unlockAlertSound()
			}
			PB.set(
				Constants.LOCAL_STORAGE_IDS.STATUS_ALERT_MUTED,
				muted ? 'true' : 'false',
			)
			EventBus.emit(Constants.EVENTS.STATUS_ALERT_MUTE_CHANGED, muted)
			Utils.showSuccessMessage('Settings have been saved succcessfully.')
			this.before = this.selection
		},
	},
})
</script>
